import '../../monitoring/filters/keyword/keywords_filter_view.js.coffee'

class Customer.Filters.KeywordsFilterView extends Monitoring.Views.SocialContents.Filters.KeywordsFilterView
  template: JST["backbone/templates/customer/filters/keywords_filter"]

  render:->
    super
    [@firstGroupView, @secondGroupView, @excludedGroupView].map (view) =>
      @listenTo(view, 'KeywordsFilterGroupView:onChange', @onChangeGroup)
    @

  onChangeGroup:->
    @_keepCustomerSessionAlive()

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
